import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const pdsDropdownMenuSeparatorCss = ":host hr{border:1px solid var(--pine-color-border);margin-block:var(--pine-dimension-xs)}";

const PdsDropdownMenuSeparator$1 = /*@__PURE__*/ proxyCustomElement(class PdsDropdownMenuSeparator extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * It determines whether or not the dropdown-item is disabled.
         * @defaultValue false
         */
        this.disabled = false;
    }
    render() {
        return (h(Host, { key: '71b19470921b7848e5f0c44ef82aa0d9f8ef2017', id: this.componentId }, h("hr", { key: 'efc84b6b3f3f35421c0af863fb2d4636e542773e' })));
    }
    static get style() { return pdsDropdownMenuSeparatorCss; }
}, [1, "pds-dropdown-menu-separator", {
        "componentId": [1, "component-id"],
        "disabled": [4]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["pds-dropdown-menu-separator"];
    components.forEach(tagName => { switch (tagName) {
        case "pds-dropdown-menu-separator":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PdsDropdownMenuSeparator$1);
            }
            break;
    } });
}

const PdsDropdownMenuSeparator = PdsDropdownMenuSeparator$1;
const defineCustomElement = defineCustomElement$1;

export { PdsDropdownMenuSeparator, defineCustomElement };
//# sourceMappingURL=pds-dropdown-menu-separator.js.map

//# sourceMappingURL=pds-dropdown-menu-separator.js.map